import styled from 'styled-components';

export const Wrap = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background-color: ${({ theme }) => theme['color.overlay.background']};
  opacity:0.5;
  display: none;
  ${({ show }) => show && `
  display: flex;
  `}
`;

export const Toast = styled.div`
  display:flex;
  min-width: 260px;
  height: 50px;
  padding: 15px;
  border-radius: 4px;
  border-radius: 4px;
  box-shadow: 0 0 16px 0 rgba(0,0,0,0.08), 0 2px 4px 0 rgba(0,0,0,0.16), 0 5px 14px 0 rgba(0,0,0,0.1);
  background-color: ${({ theme }) => theme['color.overlay.toast.background']};

  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: ${({ theme }) => theme['color.overlay.text.toast']};
`;

export const Text = styled.div`
  padding-left: 10px;
`;

export const ToastWrap = styled.div`
  z-index: 1500;
  position: fixed;
  top: 70px;
  left: 50%;

  transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
  transform: translate(-50%, calc(-100% - 70px));
  opacity: 0;
  ${({ show }) => show && `
    transform: translateX(-50%);
    opacity: 1;
  `}
`;
